export const brandDomain = 'playsbti.pages.dev';
export const brandUrl = 'https://playsbti.pages.dev/';
export const brandLogoPath = '/assets/brand/playsbti-logo.svg';
export const brandQrPath = '/assets/brand/playsbti-qr.svg';
